import { createContext, useContext } from "react";

const IdiomaContext = createContext({
  idioma: "es",
  setIdioma: () => {},
  idiomasDisponibles: ["es"],
  posicionBoton: "top-right",
  tamanoBoton: "medium",
  margenBoton: 12,
});

export function useIdiomaContext() {
  return useContext(IdiomaContext);
}

export default IdiomaContext;
